import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import NotificationsComponent from './NotificationsComponent';

import {
  clearCUNotifications,
  getCUNotifications,
  markAsViewedByScopes,
  toggleCUNotifications,
} from './actions';

import { NOTIFICATIONS_LIST_LIMIT, SCOPE_NOTIFICATIONS } from './constants';

import * as selectors from './selectors';

import NotificationsDrawer from './NotificationsDrawer';

export const CUNotificationsContainer = (props) => {
  const {
    toggleCUNotifications,
    getCUNotifications,
    clearCUNotifications,
    markAllAsViewed,
    isCUNotificationsShown,
    isLoading,
    notifications,
    nextNotifications,
    prevNotifications,
  } = props;

  const [isViewed, setIsViewed] = useState(false);

  const timeoutID = useRef(null);

  const onLoad = () => {
    getCUNotifications({ limit: NOTIFICATIONS_LIST_LIMIT }, true);
    timeoutID.current = setTimeout(() => {
      setIsViewed(true); // mark all as viewed on UI after 3 sec
    }, 5000);
  };

  const getNextNotifications = () =>
    nextNotifications && getCUNotifications(nextNotifications);
  const getPrevNotifications = () =>
    prevNotifications && getCUNotifications(prevNotifications);

  const onDrawerOpen = () => {
    toggleCUNotifications();
  };
  const onDrawerClose = () => {
    toggleCUNotifications();
    clearCUNotifications();
  };

  useEffect(() => {
    if (isCUNotificationsShown) onLoad();
  }, [isCUNotificationsShown]);

  useEffect(
    () => () => timeoutID.current && clearTimeout(timeoutID.current),
    [],
  );

  return (
    <NotificationsDrawer
      isCUNotificationsShown={isCUNotificationsShown}
      onDrawerOpen={onDrawerOpen}
      onDrawerClose={onDrawerClose}
    >
      <NotificationsComponent
        isViewed={isViewed}
        getNextNotifications={getNextNotifications}
        getPrevNotifications={getPrevNotifications}
        markAllAsViewed={markAllAsViewed}
        isLoading={isLoading}
        notifications={notifications}
        hasNextPage={!!nextNotifications}
        onDrawerClose={onDrawerClose}
      />
    </NotificationsDrawer>
  );
};

CUNotificationsContainer.defaultProps = {
  nextNotifications: null,
  prevNotifications: null,
};

CUNotificationsContainer.propTypes = {
  toggleCUNotifications: PropTypes.func.isRequired,
  getCUNotifications: PropTypes.func.isRequired,
  clearCUNotifications: PropTypes.func.isRequired,
  markAllAsViewed: PropTypes.func.isRequired,
  isCUNotificationsShown: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  notifications: PropTypes.instanceOf(Array).isRequired,
  nextNotifications: PropTypes.instanceOf(Object),
  prevNotifications: PropTypes.instanceOf(Object),
};

const mapStateToProps = (state) => ({
  isLoading: selectors.getIsLoading(state),
  isCUNotificationsShown: selectors.getIsCUNotificationsShown(state),
  notifications: selectors.getCUNotifications(state),
  nextNotifications: selectors.getCUNextNotifications(state),
  prevNotifications: selectors.getCUPrevNotifications(state),
});

const mapDispatchToProps = (dispatch) => ({
  toggleCUNotifications: () => toggleCUNotifications(dispatch),
  getCUNotifications: (queryParams, isClearPrevious) =>
    getCUNotifications(dispatch, queryParams, isClearPrevious),
  markAllAsViewed: () => markAsViewedByScopes(dispatch, [SCOPE_NOTIFICATIONS]),
  clearCUNotifications: () => clearCUNotifications(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CUNotificationsContainer);
